import React, { useState, useEffect, useRef } from 'react';
import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import './modal-dialog.css';
import './formEditUser.scss';
import { useForm } from 'react-hook-form';
import { Modal, Button } from 'react-bootstrap';

const FormOTPPhoneEmail = ({
  showOTPModal,
  getOtpPhoneEmail,
  completeUser,
  closeOTPModal,
  modalTitle,
  hasChangedMail,
  hasChangedPhone,
  newPhone,
  newEmail,
  values,
  onSubmitWithOTP,
  updateError = {},
  setModalTitle,
  setUpdateError,
  loading,
}) => {
  let dialogInstance = useRef(null);
  const [errorPhone, setErrorPhone] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorBoth, setErrorBoth] = useState(false);

  const { register, handleSubmit, reset, formState: { errors } } = useForm();

  useEffect(() => {
    const telefonoStatus = updateError?.response?.data?.telefono?.status;
    const emailStatus = updateError?.response?.data?.email?.status;

    if (telefonoStatus !== undefined && telefonoStatus !== 0 && !errorBoth) {
      reset({ otpPhone: '' });
      setErrorPhone(true);
      setErrorBoth(false);
    }

    if (emailStatus !== undefined && emailStatus !== 0 && !errorBoth) {
      reset({ otpEmail: '' });
      setErrorEmail(true);
      setErrorBoth(false);
    }

    if (telefonoStatus !== undefined && emailStatus !== undefined &&
        telefonoStatus !== 0 && emailStatus !== 0) {
      reset({ otpPhone: '', otpEmail: '' });
      setErrorBoth(true);
    }
  }, [showOTPModal, updateError]);

  const dialogClose = () => {
    reset({ otpPhone: '', otpEmail: '' });
    setErrorPhone(false);
    setErrorEmail(false);
    setErrorBoth(false);
    setUpdateError({});
    closeOTPModal();
  };

  const handleGenerateEmailCode = () => {
    setModalTitle('Hemos enviado de nuevo código a su email');
    setUpdateError({});
    setErrorPhone(false);
    setErrorEmail(false);
    setErrorBoth(false);
    getOtpPhoneEmail(completeUser.id, null, newEmail);
  };

  const handleGeneratePhoneCode = () => {
    setModalTitle('Hemos enviado de nuevo código a su teléfono');
    setUpdateError({});
    setErrorPhone(false);
    setErrorEmail(false);
    setErrorBoth(false);
    getOtpPhoneEmail(completeUser.id, newPhone, null);
  };

  const handleGenerateBothCode = () => {
    setModalTitle('Hemos enviado de nuevo código a su email y su teléfono');
    setUpdateError({});
    setErrorPhone(false);
    setErrorEmail(false);
    setErrorBoth(false);
    setTimeout(() => {
      getOtpPhoneEmail(completeUser.id, newPhone, newEmail);
    }, 100);
  };

  const onSubmit = (data) => {
    onSubmitWithOTP(values, data?.otpPhone || '', data?.otpEmail || '');
  };

  const hideFirstDigits = (phone) => '****' + phone?.slice(-4);
  const hideEmail = (email) => {
    const atIndex = email?.indexOf('@');
    return atIndex !== -1 ? email?.substring(0, atIndex) + '@***' : '***@***';
  };

  const getTelefonoMessage = () => updateError?.response?.data?.telefono?.message;
  const getEmailMessage = () => updateError?.response?.data?.email?.message;

  return (
    <Modal
      show={showOTPModal}
      onHide={dialogClose}
      centered
      ref={dialogInstance}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h2 className='title-insert-otp'>{modalTitle}</h2>
          {updateError?.response?.status === 500 &&
            <p className='form-error'>No hemos podido procesar su petición</p>
          }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id="otpFormEmailPhone">
          {hasChangedPhone && !hasChangedMail && (
            <div className="form-group">
              <label htmlFor="otpPhone">Código para teléfono: {hideFirstDigits(newPhone)}</label>
              <input
                type="text"
                className="form-control"
                id="otpPhone"
                {...register("otpPhone", {
                  required: "Campo requerido",
                  maxLength: { value: 6, message: "Máximo 6 caracteres" }
                })}
              />
              {errorPhone && getTelefonoMessage() && (
                <p className="form-error">{getTelefonoMessage()}</p>
              )}
              {errors.otpPhone && (
                <p className="form-error">{errors.otpPhone.message}</p>
              )}
            </div>
          )}

          {!hasChangedPhone && hasChangedMail && (
            <div className="form-group">
              <label htmlFor="otpEmail">Código para correo electrónico: {hideEmail(newEmail)}</label>
              <input
                type="text"
                className="form-control"
                id="otpEmail"
                {...register("otpEmail", {
                  required: "Campo requerido",
                  maxLength: { value: 6, message: "Máximo 6 caracteres" }
                })}
              />
              {errorEmail && getEmailMessage() && (
                <p className="form-error">{getEmailMessage()}</p>
              )}
              {errors.otpEmail && (
                <p className="form-error">{errors.otpEmail.message}</p>
              )}
            </div>
          )}

          {hasChangedPhone && hasChangedMail && (
            <>
              <div className="form-group">
                <label htmlFor="otpPhone">Código para teléfono: {hideFirstDigits(newPhone)}</label>
                <input
                  type="text"
                  className="form-control"
                  id="otpPhone"
                  {...register("otpPhone", {
                    required: "Campo requerido",
                    maxLength: { value: 6, message: "Máximo 6 caracteres" }
                  })}
                />
                {getTelefonoMessage() && (
                  <p className="form-error">{getTelefonoMessage()}</p>
                )}
                {errors.otpPhone && (
                  <p className="form-error">{errors.otpPhone.message}</p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="otpEmail">Código para correo electrónico: {hideEmail(newEmail)}</label>
                <input
                  type="text"
                  className="form-control"
                  id="otpEmail"
                  {...register("otpEmail", {
                    required: "Campo requerido",
                    maxLength: { value: 6, message: "Máximo 6 caracteres" }
                  })}
                />
                {getEmailMessage() && (
                  <p className="form-error">{getEmailMessage()}</p>
                )}
                {errors.otpEmail && (
                  <p className="form-error">{errors.otpEmail.message}</p>
                )}
              </div>
            </>
          )}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <div className="buttons-form-otp">
          {updateError?.response?.data?.telefono?.status === 4 && !errorBoth && (
            <div className="container-btn-sbm-otp">
              <button
                className="btn-box btn-clear"
                onClick={handleGeneratePhoneCode}
              >
                Volver a Generar Código Teléfono
              </button>
            </div>
          )}

          {updateError?.response?.data?.email?.status === 4 && !errorBoth && (
            <div className="container-btn-sbm-otp">
              <button
                className="btn-box btn-clear"
                onClick={handleGenerateEmailCode}
              >
                Volver a Generar Código Email
              </button>
            </div>
          )}

          {updateError?.response?.data?.telefono?.status === 4 &&
            updateError?.response?.data?.email?.status === 4 &&
            errorBoth && (
              <div className="container-btn-sbm-otp">
                <button
                  className="btn-box btn-clear"
                  onClick={handleGenerateBothCode}
                >
                  Generar Códigos Teléfono-Email
                </button>
              </div>
          )}

          <Button
            className={`btn-box btn-accent loading btn-otpep ${loading ? "active" : ""}`}
            onClick={handleSubmit(onSubmit)}
          >
            <div className="loader-btn" />
            {loading ? "" : "Enviar"}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default FormOTPPhoneEmail;
